import React from 'react';
import { Row, Col } from 'antd';
import cx from 'classnames';

import { TourStepEnum } from 'features/onboarding/enums';

import statsFirst from 'assets/img/card1.svg';
import statSecond from 'assets/img/card2.svg';
import cardFirst from 'assets/img/card3.svg';
import cardSecond from 'assets/img/card4.svg';
import cardThird from 'assets/img/card5.svg';
import cardFourth from 'assets/img/card6.svg';

import { isTourStepActiveSelector } from 'redux/selectors/onboardingSelectors';
import { isRecruiterCompanySelector } from 'redux/selectors/authenticationSelectors';
import { useAppSelector } from 'hooks/useAppSelector';

import styles from './WelcomeTourHomePage.module.less';

export default function WelcomeTourHomePage() {
  const isRecruiterCompany = useAppSelector(isRecruiterCompanySelector);
  const isHomeDashboardTourStepActive = useAppSelector(
    isTourStepActiveSelector(TourStepEnum.HomeDashboard),
  );

  return (
    <div className="page-wrapper scroll-box">
      <div className="page-box page-holder page-inner">
        <div className="page-inner-container">
          <Row gutter={[10, 10]}>
            <Col xs={12} md={6} className="d-flex">
              <img
                src={statsFirst}
                alt="Active assignments"
                className={cx({
                  'onboarding-spotlight': isHomeDashboardTourStepActive,
                })}
              />
            </Col>

            <Col xs={12} md={6} className="d-flex">
              <img
                src={statSecond}
                alt="Financials"
                className={cx({
                  'onboarding-spotlight': isHomeDashboardTourStepActive,
                })}
              />
            </Col>
          </Row>

          <div className={styles.dashboardWrapper}>
            <div className={styles.title}>Dashboard</div>
          </div>

          <Row gutter={[10, 10]}>
            {isRecruiterCompany && (
              <Col xs={24} md={12} className="d-flex">
                <img
                  src={cardFirst}
                  alt="My customers"
                  className={cx({
                    'onboarding-spotlight': isHomeDashboardTourStepActive,
                  })}
                />
              </Col>
            )}

            <Col xs={24} md={12} className="d-flex">
              <img
                src={cardSecond}
                alt="My active assignments"
                className={cx({
                  'onboarding-spotlight': isHomeDashboardTourStepActive,
                })}
              />
            </Col>

            <Col xs={24} md={12} className="d-flex">
              <img
                src={cardThird}
                alt="Timesheet status report"
                className={cx({
                  'onboarding-spotlight': isHomeDashboardTourStepActive,
                })}
              />
            </Col>

            <Col xs={24} md={12} className="d-flex">
              <img
                src={cardFourth}
                alt="Assignment ending soon"
                className={cx({
                  'onboarding-spotlight': isHomeDashboardTourStepActive,
                })}
              />
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
}
